/*! @azure/msal-common v9.0.0 2022-11-22 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "9.0.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
